export function removeSpecialChars(texto) {
	const textoSemAcentos = texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
	const textoLimpo = textoSemAcentos.replace(/[^a-zA-Z0-9 ]/g, "");
	return textoLimpo;
}

export function capitalize(str) {
	if (!str) return "";
	return str.charAt(0).toUpperCase() + str.slice(1);
}

export function slugify(text, separator = '-') {
	if (!text) {
		return '';
	}

	let slug = text.toLowerCase().trim();

	// Remove accents/diacritics
	slug = slug.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

	slug = slug.replace(/[^a-z0-9\s-]/g, ' ');

	slug = slug.replace(/[\s-]+/g, separator);

	// Remove leading/trailing hyphens (if any were introduced by replacements)
	slug = slug.replace(/^-+|-+$/g, '');

	return slug;
}

export function toCamelCase(str) {

	let _str = slugify(str);

	return _str
		.split('-')
		.filter(Boolean)
		.map((word, idx) => {
			if (idx === 0) return word.toLowerCase();
			return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
		})
		.join('');
}

/**
 * Converte uma palavra para o plural em português
 * @param {string} palavra - A palavra a ser pluralizada
 * @returns {string} - A palavra no plural
 * 
 * @example
 * pluralizePortuguese('cão') // 'cães'
 * pluralizePortuguese('gato') // 'gatos'
 * pluralizePortuguese('hotel') // 'hotéis'
 */
export function pluralizePortuguese(palavra) {
	if (!palavra || typeof palavra !== 'string') return palavra;

	const word = palavra.toLowerCase().trim();

	if (word.length === 0) return word;

	// Palavras terminadas em "ão"
	if (word.endsWith('ão')) {
		// Exceções comuns
		if (word.endsWith('não')) return word.slice(0, -3) + 'nões';
		if (word.endsWith('ção')) return word.slice(0, -3) + 'ções';
		return word.slice(0, -2) + 'ões';
	}

	// Palavras terminadas em "ãe"
	if (word.endsWith('ãe')) {
		return word.slice(0, -2) + 'ães';
	}

	// Palavras terminadas em "al"
	if (word.endsWith('al')) {
		return word.slice(0, -2) + 'ais';
	}

	// Palavras terminadas em "el"
	if (word.endsWith('el')) {
		return word.slice(0, -2) + 'eis';
	}

	// Palavras terminadas em "il"
	if (word.endsWith('il')) {
		return word.slice(0, -2) + 'is';
	}

	// Palavras terminadas em "ol"
	if (word.endsWith('ol')) {
		return word.slice(0, -2) + 'ois';
	}

	// Palavras terminadas em "ul"
	if (word.endsWith('ul')) {
		return word.slice(0, -2) + 'uis';
	}

	// Palavras terminadas em "m"
	if (word.endsWith('m')) {
		return word.slice(0, -1) + 'ns';
	}

	// Palavras terminadas em "r"
	if (word.endsWith('r')) {
		return word + 'es';
	}

	// Palavras terminadas em "z"
	if (word.endsWith('z')) {
		return word + 'es';
	}

	// Palavras terminadas em "s" (geralmente já estão no plural, mas adiciona 'es' para singular)
	if (word.endsWith('s')) {
		// Se termina em uma vogal + s, provavelmente já é plural
		const vowels = ['a', 'e', 'i', 'o', 'u'];
		if (word.length > 1 && vowels.includes(word[word.length - 2])) {
			return word; // Já é plural
		}
		return word + 'es';
	}

	// Caso padrão: adiciona "s"
	return word + 's';
}

export function joinWithCommaAnd(list) {
	if (!list || list.length === 0) return '';
	if (list.length === 1) return list[0];
	if (list.length === 2) return `${list[0]} e ${list[1]}`;

	return `${list.slice(0, -1).join(', ')} e ${list[list.length - 1]}`;
}

export function splitCommaAnd(str) {
	if (!str) return [];

	const normalized = str.trim();

	const parts = normalized.split(/\s+e\s+/);

	if (parts.length === 1) {
		return parts[0].split(',').map(s => s.trim()).filter(Boolean);
	}

	const last = parts.pop();
	const firstPart = parts.join(' e ');

	const items = firstPart
		.split(',')
		.map(s => s.trim())
		.filter(Boolean);

	items.push(last.trim());

	return items;
}

export function numberToMoney(value) {
	const formattedValue = `R$ ${value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+,)/g, '$1.')}`;
	return formattedValue;
}

export function sanitizeNumeric(input) {
	if (!input) {
		return null;
	}
	if (typeof input !== "string") {
		return "";
	}

	return input.replace(/\D/g, "");
}